import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.grid = document.querySelector('[data-grid="grid"]');

        document.addEventListener('keydown', (event) => {
            // Check if Ctrl key is pressed and the key is '/'
            if (event.ctrlKey && event.key === '/') {
                this.grid.classList.toggle("opacity-0");
            }
        });
    }
}
